import FormBuilderConfig from "../../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import ISelectBuilder from "../../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import IButtonBuilder from "../../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import IUserSelectorBuilder from "../../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";
import { userHasPermission } from "../../../../utils/accessTree";

const mesesOpts = [
  { value: "01", label: "Enero" },
  { value: "02", label: "Febrero" },
  { value: "03", label: "Marzo" },
  { value: "04", label: "Abril" },
  { value: "05", label: "Mayo" },
  { value: "06", label: "Junio" },
  { value: "07", label: "Julio" },
  { value: "08", label: "Agosto" },
  { value: "09", label: "Septiembre" },
  { value: "10", label: "Octubre" },
  { value: "11", label: "Noviembre" },
  { value: "12", label: "Diciembre" }
];

const currentYear = new Date().getFullYear();
const aniosOpts = [
  { label: currentYear, value: currentYear },
  { label: currentYear - 1, value: currentYear - 1 },
  { label: currentYear - 2, value: currentYear - 2 }
];

export type Inputs = "mes" | "anio" | "idLider";
export type Buttons = "buscar";

export const formConfig: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "mes",
      label: "* Mes",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione",
        data: mesesOpts
      }
    },
    {
      name: "anio",
      label: "Año",
      bts: { mCol: 2 },
      component: ISelectBuilder,
      props: {
        emptyLabel: currentYear.toString(),
        data: aniosOpts
      }
    },
    {
      name: "idLider",
      label: "Líder Comercial",
      bts: { mCol: 5 },
      component: IUserSelectorBuilder,
      props: {
        hidden: () => !userHasPermission(57401)
      }
    }
  ],
  buttons: [
    {
      name: "buscar",
      label: "Buscar",
      isSubmit: true,
      bts: { mCol: 3 },
      component: IButtonBuilder
    }
  ],
  validations: {
    mes: {
      required: {
        validator: value => !value,
        message: () => "El mes es requerido"
      }
    }
  },
  rows: [["mes", "anio", "idLider", "buscar"]]
};

export const selectClubFormConfig: FormBuilderConfig<"idClub", "aceptar"> = {
  inputs: [
    {
      name: "idClub",
      label: "Seleccione el Club",
      bts: { mCol: 12 },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione",
        data: []
      }
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Aceptar",
      isSubmit: true,
      bts: { mCol: 12 },
      component: IButtonBuilder
    }
  ],
  validations: {
    idClub: {
      required: {
        validator: value => !value,
        message: () => "Seleccione un club"
      }
    }
  },
  rows: [["idClub"], ["aceptar"]]
};
